import { useState, useEffect } from 'react'
import './ProgressiveImage.scss'

type ProgressiveImageProps = {
  src: string
  thumbnail: string
  alt: string
  className?: string
  onClick?: () => void
  loading?: 'lazy' | 'eager'
  onLoad?: (loaded: boolean) => void
}

function ProgressiveImage({ src, thumbnail, alt, className = '', onClick, loading = 'lazy', onLoad }: ProgressiveImageProps) {
  const [imgSrc, setImgSrc] = useState(thumbnail)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    // Lade das hochauflösende Bild im Hintergrund
    const img = new Image()

    img.onload = () => {
      setImgSrc(src)
      setIsLoaded(true)
      if (onLoad) {
        onLoad(true)
      }
    }

    img.src = src
  }, [src, onLoad])

  return (
    <div className={`progressive-image ${className}`} onClick={onClick}>
      <img
        src={imgSrc}
        alt={alt}
        className={`progressive-image__img ${isLoaded ? 'progressive-image__img--loaded' : 'progressive-image__img--loading'}`}
        loading={loading}
      />
    </div>
  )
}

export default ProgressiveImage
